import { createTranslationsPageProvider } from '@edreamsodigeo/frontend-core';
export const BrokenFlowModalTranslationsProvider = createTranslationsPageProvider({
  checkout: ({
    brand,
    locale
  }) => import(/* webpackChunkName: "[request]" */`@edreamsodigeo/frontend-additional-products/translations/${brand}/${locale}/errors.js`)
});